module.exports = __webpack_public_path__ + "static/img/Arshina-Logo-Footer-600x367.1759f08c.png";